import { Service } from "models/Service";

export class LandingEMQV extends Service {
  constructor() {
    super({
      adsPath: "servicios/home",
      meta: {
        description: `El mundo que viene - Clarin.com`,
        keywords: '',
        title: `El mundo que viene - Clarin.com`,
        url: `/Elmundoqueviene`, 
        extra: [],
      },
      section: "Elmundoqueviene",
      sectionName: "",
      template: "LandingEMQV",
      title: ``,
      widthFull: true,
      slug: "",
      titleHeader:"",
      width100: true,
      bannersOn: false
    });    
  }

}